<template>
  <div class="privacy-terms">
    <div class="header">{{$t('account.reg.privacyTitle')}}</div>
    <div class="content" :style="`max-height:${maxHeight}px;height:${height}px`">
      <iscroll-view class="scroll-view" :options="{disableTouch: true, momentum: false, mouseWheel: true, scrollbars: true, fadeScrollbars: false, interactiveScrollbars: true}" ref="iscroll" :style="`right:-${rightNum}px;`">
        <div class="sidebar-wrap" :style="`padding-right:${rightNum}px;`">
          <section>
            <h1>【首部及导言】</h1>
            <p>欢迎您使用由上海科橘信息科技有限公司提供的O-TECH关税服务软件及服务！</p>
            <p><strong>为使用O-TECH关税服务软件（以下简称“本软件”）及服务，您应当阅读并遵守《O-TECH软件许可及服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议（如有），并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。</strong></p>
            <p><strong>除非您已阅读并接受本协议所有条款，否则您无权使用本软件及相关服务。您登录、接入或使用本软件等行为即视为您已阅读并同意接受本协议的约束。此后您不得以未阅读/未同意本协议内容或类似的理由提出任何形式的抗辩。</strong></p>
          </section>
          <section>
            <h1>一、【协议的范围】</h1>
            <p>1.1【协议适用范围】</p>
            <p class="desc">本协议适用范围包括：在本软件系统中所进行的一切相关服务和工具。除非另有明确规定，本软件增加或强化目前服务的任何新内容、新功能，包括新产品，均无条件地适用本协议。</p>
            <p>1.2【协议适用主体】</p>
            <p class="desc">上海科橘信息科技有限公司服务内容（以下简称“服务”）仅提供给接受本协议规定，并进行合法登记的组织或具有完全民事行为能力的个人使用；同时，上海科橘信息科技有限公司在认为有合理理由的情况下，有权随时决定拒绝向任何个人或组织提供服务。</p>
            <p>1.3【协议关系及冲突条款】</p>
            <p class="desc"><strong>本协议的内容，包括但不限于与本软件相关的协议、规则、规范以及上海科橘信息科技有限公司可能不断发布的关于本软件的相关协议、规则、规范等内容，前述内容一经正式发布，即为本协议不可分割的组成部分，与其构成统一整体，您同样应当遵守。</strong></p>
          </section>
          <section>
            <h1>二、【关于软件服务】</h1>
            <p>2.1【软件服务内容】</p>
            <p class="desc">软件服务内容是指上海科橘信息科技有限公司通过本软件向用户提供的优惠关税信息查询以及税务筹划服务（以下简称“本服务”）。</p>
            <p>2.2【软件服务形式】</p>
            <p class="desc">您可能可以通过电脑、手机等终端以API接入、登录网页等形式使用本服务，具体以上海科橘信息科技有限公司提供的为准，同时，上海科橘信息科技有限公司会不断丰富您使用本服务的终端、形式等。当您使用本服务时，您应选择与您的终端、系统等相匹配的本软件版本，否则，您可能无法正常使用本服务。</p>
            <p>2.3【许可的范围】</p>
            <p class="desc">2.3.1 在您接受本协议各项条款约束，且遵守为使您有权使用本“软件”而与上海科橘信息科技有限公司签订的其他协议（如有）或为证明您有权使用本软件而由上海科橘信息科技有限公司出具的授权文件（如有）中的全部条款和条件的前提下， 上海科橘信息科技有限公司将本软件在中华人民共和国（"中国"）大陆地区（除香港特别行政区、澳门特别行政区、台湾地区外的中国境内）给予您一项个人的、不可转让及非排他性的许可使用权。您可以在满足本软件运行环境要求的终端设备上以非商业目的登录、接入、显示、运行本软件，但不得以任何方式将本软件转让与他人（包括但不限于有偿、无偿、单独、与其他软、硬件一并转让）。</p>
            <p class="desc">2.3.2 本条款及本协议其他条款未明示授权的其他一切权利仍由上海科橘信息科技有限公司保留，您在行使这些权利时须另外取得上海科橘信息科技有限公司的书面许可。上海科橘信息科技有限公司如果未行使前述任何权利，并不构成对该权利的放弃。</p>
          </section>
          <section>
            <h1>三、【软件登录与接入】</h1>
            <p>3.1 您可通过访问otechsolution.com登录本软件，也可从上海科橘信息科技有限公司授权的第三方接口接入本软件。</p>
            <p>3.2 如果您从未经上海科橘信息科技有限公司授权的第三方接口接入本软件，上海科橘信息科技有限公司无法保证软件能够正常使用，亦不承担您使用本软件所导致的任何不利后果。</p>
          </section>
          <section>
            <h1>四、【软件的更新】</h1>
            <p>为了增进用户体验、完善服务内容，上海科橘信息科技有限公司将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
          </section>
          <section>
            <h1>五、【用户个人信息保护】</h1>
            <p>5.1 保护用户个人信息是上海科橘信息科技有限公司的一项基本原则，上海科橘信息科技有限公司将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可上海科橘信息科技有限公司不会向第三方公开、透露用户个人信息。上海科橘信息科技有限公司对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。</p>
            <p>5.2 您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规或政策有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
            <p>5.3 一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。<strong>同时，请您妥善保管您的网站注册账户及密码，若因您保管不善导致任何损失，上海科橘信息科技有限公司不承担任何责任。</strong></p>
            <p>5.4 上海科橘信息科技有限公司将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
            <p>5.5 在您使用本服务过程中，上海科橘信息科技有限公司可能会向您收集包括但不限于如下信息：【所在地理位置信息、查询的商品编码信息、查询商品的目的地信息、节税金额信息等】。该等被收集的信息将被用于如下目的：【撰写FTA使用情况报告时参考】。</p>
            <p>5.6 您应保证向上海科橘信息科技有限公司提交的信息真实、准确、完整、合法和有效，如因信息存在虚假、不准确、遗漏、违法或失效而造成上海科橘信息科技有限公司损失的（包括但不限于监管机构处罚等），您需要就该等损失承担全部赔偿责任。</p>
          </section>
          <section>
            <h1>六、【用户行为规范】</h1>
            <p>6.1【用户注意事项】</p>
            <p class="desc">6.1.1 您充分理解并同意：您在使用本服务某一特定服务时，本服务可以使用您终端设备的相关权限、接口及相关信息等以实现相应的功能，某些特定服务可能还需同意单独的协议、规则等，您在使用该项服务前请仔细阅读前述相关协议、规则。</p>
            <p class="desc">6.1.2 上海科橘信息科技有限公司有权在本服务中或通过本服务向您展现各种信息，包括但不限于广告信息、新闻信息及宣传信息等，该信息可能以系统消息或弹出窗口等形式出现。</p>
            <p class="desc">6.1.3 您可以选择不向上海科橘信息科技有限公司提供您的某些信息，或者根据产品设置取消上海科橘信息科技有限公司收集某些信息，但因此可能会导致相关服务功能无法实现。</p>
            <p class="desc">6.1.4 您理解并同意：上海科橘信息科技有限公司将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，上海科橘信息科技有限公司并不能就此提供完全保证，包括但不限于以下情形：</p>
            <p class="desc2">（1）上海科橘信息科技有限公司不对您在本软件及服务中相关数据的删除或储存失败负责；</p>
            <p class="desc2">（2）上海科橘信息科技有限公司有权根据实际情况自行决定您在本软件及服务中数据的最长储存期限、服务器中数据的最大存储空间等，您可根据自己的需要自行备份本软件及服务中的相关数据。双方另有约定的按相应约定执行；</p>
            <p class="desc2">（3）如果您停止使用本软件及服务或服务被终止或取消，上海科橘信息科技有限公司可以从服务器上永久地删除您的数据。您的服务停止、终止或取消后，上海科橘信息科技有限公司没有义务向您返还任何数据。</p>
            <p class="desc">6.1.5 如果您通过任何方式或任何媒体向本软件提交的数据或其他信息（以下统称为“信息”，此“信息”包括但不限于用于改进本软件及与使用本软件相关的服务而提交的数据、思想、概念或技术，不论是作为反馈、数据、问题、评价、建议等）给上海科橘信息科技有限公司，都被视为您同意所有这些信息都是不受限制的、非机密的。另外，您还同意上海科橘信息科技有限公司拥有永久的、不可剥夺的、非专属的在全球范围内使用这些信息的权利，而不负有向您付款、赔偿或支付酬金的义务。 上海科橘信息科技有限公司在本条款中的权利还应包括使用、复制、传送和散布所有您提交的信息，创造由此衍生出来的作品，显示和执行所有您提交的信息，以及允许第三方进行以上行为的权利。</p>
            <p>6.2【五不准】</p>
            <p class="desc">您在使用本服务时不得利用本服务从事以下行为，包括但不限于：</p>
            <p class="desc2">（1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</p>
            <p class="desc2">（2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
            <p class="desc2">（3）虚构事实、隐瞒真相以误导、欺骗他人；</p>
            <p class="desc2">（4）发表、传送、传播广告信息及垃圾信息；</p>
            <p class="desc2">（5）从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</p>
            <p>6.3【用户禁止行为】</p>
            <p class="desc">除非法律允许或上海科橘信息科技有限公司书面许可，您不得从事下列行为：</p>
            <p class="desc2">（1）删除本软件及其副本上关于著作权的信息；</p>
            <p class="desc2">（2）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
            <p class="desc2">（3）对上海科橘信息科技有限公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
            <p class="desc2">（4）对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非上海科橘信息科技有限公司经授权的第三方工具/服务接入本软件和相关系统；</p>
            <p class="desc2">（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
            <p class="desc2">（6）通过非上海科橘信息科技有限公司开发、授权的第三方软件、插件、外挂、系统，登录或使用上海科橘信息科技有限公司软件及服务，或制作、发布、传播上述工具；</p>
            <p class="desc2">（7）自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰；</p>
            <p class="desc2">（8）其他未经上海科橘信息科技有限公司明示授权、许可或违反本协议及相关协议、规则的行为。</p>
            <p>6.4【对自己行为负责】</p>
            <p class="desc"><strong>您充分了解并同意，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。上海科橘信息科技有限公司无法且不会对您因前述风险而导致的任何损失或损害承担责任。</strong></p>
            <p>6.5【对第三方损害的处理】</p>
            <p class="desc">您违反约定，导致任何第三方损害的，您应当独立承担责任；上海科橘信息科技有限公司因此遭受损失的，您也应当一并赔偿。</p>
          </section>
          <section>
            <h1>七、本服务的中断、中止和终止</h1>
            <p>7.1 您的下列行为将导致全部或部分本服务的中止与终止：（1）您发生本协议6.2条及6.3条罗列的行为；（2）您在接受本服务时实施不正当行为；（3）您提供虚假注册身份信息，或实施违法本协议的行为。在您有任一前述行为时，上海科橘信息科技有限公司有权不经通知采取服务中止措施。</p>
            <p>7.2 为了确保本服务的正常运行，需要定期对本服务的客户端、服务器和/或数据库进行维护或针对突发事件进行紧急停机维护；因上述情况造成的正常服务中断、中止，请您予以理解。</p>
            <p>7.3 发生下列情形之一时，上海科橘信息科技有限公司有权中断或中止所提供的全部或部分服务，并且，对因此而产生的不便或损害，上海科橘信息科技有限公司对您或第三人均不承担任何责任：</p>
            <p class="desc">（1）对客户端、服务器和/或数据库进行定期维护或检查，更新软件或硬件等；</p>
            <p class="desc">（2）因服务器或其他任何原因导致本服务无法正常运作；</p>
            <p class="desc">（3）因第三方软件发生任何瑕疵、故障、错误或其他原因，导致无法正常服务；</p>
            <p class="desc">（4）突发性的软硬件设备与电子通信设备故障；</p>
            <p class="desc">（5）网络提供商线路及其他故障；</p>
            <p class="desc">（6）在紧急情况下依照法律的规定；</p>
            <p class="desc">（7）第三方原因或其他不可抗力的情形。</p>
          </section>
          <section>
            <h1>八、【第三方提供的产品或服务】</h1>
            <p>8.1 您在上海科橘信息科技有限公司平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。上海科橘信息科技有限公司和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
            <p><strong>8.2 因用户使用本软件或要求上海科橘信息科技有限公司提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供（包括但不限于您通过本服务跳转到的第三方提供的服务及内容，第三方通过上海科橘信息科技有限公司开放平台接入的服务及内容等），上海科橘信息科技有限公司无法保证第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，您应自行承担相关责任。</strong></p>
            <p>8.3 关于在线支付服务</p>
            <p class="desc">8.3.1 您知悉并同意，为使用本软件服务功能之目的，您可能会需要使用第三方提供的在线支付服务以进行资金支付和结算。为此，您应当遵守如下要求：</p>
            <p class="desc2">（1）您应当向提供在线支付服务的第三方（以下简称“支付机构”）提交现时有效的身份证件，用于开立您的唯一标识。该唯一标识是支付机构根据您提供的身份信息生成的、用于记录您交易明细及待结算资金的唯一标识。您的唯一标识将与您在本软件系统注册的账户绑定。您向支付机构或上海科橘信息科技有限公司提交身份证件的行为将视为您同意开立该等唯一标识，代表您的真实开户意愿。</p>
            <p class="desc2">（2）您应保证向支付机构提交的所有个人资料真实、准确、完整、合法和有效，如因资料存在虚假、不准确、遗漏、违法或失效而造成支付机构和/或上海科橘信息科技有限公司损失的（包括但不限于监管机构处罚等），您需要就该等损失承担全部赔偿责任。</p>
            <p class="desc2">（3）您不得将唯一标识用于本协议和本软件以外的用途，也不得出租、转让给任何第三方使用。</p>
            <p class="desc2">（4）您使用支付机构的支付服务时，应确保所提交的支付数据信息的合法性、真实性、准确性和完整性，如因您提供的支付数据信息不合法、不真实、不准确、不完整或因您的其他原因而产生的差错，由您承担责任。</p>
            <p class="desc2">（5）您应当是进行在线支付操作时所绑定银行卡的合法持有人，对该银行卡的使用不得侵犯任何第三人的合法权益。如因您非所绑定银行卡合法持有人并给合法持卡人造成损失的，您应承担全部赔偿责任；如合法持卡人向上海科橘信息科技有限公司主张赔偿导致上海科橘信息科技有限公司损失的，上海科橘信息科技有限公司有权向您追偿因此遭受的全部损失。</p>
            <p class="desc2">（6）请您妥善保存银行卡账户、预留手机号等信息，因您对账号和密码保管及使用不当而造成的一切损失由您本人承担。</p>
            <p class="desc2">（7）您的取现银行卡与在线支付功能下绑定的银行卡应为同户名银行账户。</p>
            <p class="desc">8.3.2 为了您使用在线支付服务之目的，您在此同意、许可并授权上海科橘信息科技有限公司向支付机构提供您的信息。</p>
            <p class="desc">8.3.3 您理解并确认，您在支付机构开立的唯一标识所记录的资金明细不同于您本人的银行存款，不受《存款保险条例》保护，其实质为您委托支付机构保管的、所有权归属于您的待结算金额。该金额对应的货币资金虽然属于您，但不以您本人名义存放在银行，而是以支付机构名义存放在银行，并且由支付机构向银行发起结算至上海科橘信息科技有限公司或您的银行账户。</p>
          </section>
          <section>
            <h1>九、【知识产权声明】</h1>
            <p>9.1 上海科橘信息科技有限公司是本软件的知识产权权利人。本软件的著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，上海科橘信息科技有限公司依法享有上述相关知识产权，但相关权利人依照法律规定应享有的权利除外。</p>
            <p>9.2 未经上海科橘信息科技有限公司或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</p>
          </section>
          <section>
            <h1>十、【终端安全责任】</h1>
            <p><strong>10.1 您理解并同意，本软件或本服务同大多数互联网软件、服务一样，可能会受多种因素影响（包括但不限于用户原因、网络服务质量、社会环境等）；也可能会受各种安全问题的侵扰（包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您终端的信息和数据的安全，继而影响本软件、本服务的正常使用等）。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。</strong></p>
            <p><strong>10.2 维护软件安全与正常使用是上海科橘信息科技有限公司和您的共同责任，上海科橘信息科技有限公司将按照行业标准合理审慎地采取必要技术措施保护您的终端信息和数据安全，但是您承认和同意上海科橘信息科技有限公司不能就此提供任何保证。</strong></p>
            <p><strong>10.3 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意上海科橘信息科技有限公司有关防范诈骗犯罪的提示。</strong></p>
          </section>
          <section>
            <h1>十一、【第三方软件或技术】</h1>
            <p>11.1 本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
            <p>11.2 本软件如果使用了第三方的软件或技术，上海科橘信息科技有限公司将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。<strong>如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求上海科橘信息科技有限公司给予协助，您应当自行承担法律责任。</strong>。</p>
          </section>
          <section>
            <h1>十二、【责任限制】</h1>
            <p><strong>对于您因下列情况所遭受的损害，上海科橘信息科技有限公司不承担责任：</strong></p>
            <p class="desc"><strong>（1）因第三方服务提供者未能提供电信服务（包括但不限于电话和互联网）而导致您无法使用服务；</strong></p>
            <p class="desc"><strong>（2）因第三方软件的任何瑕疵、故障或其他问题导致您无法使用服务；</strong></p>
            <p class="desc"><strong>（3）因您自身拥有或使用的设备、软件或网络设施的任何问题或故障导致您无法使用服务；</strong></p>
            <p class="desc"><strong>（4）因您或您承包商或代理人的故意行为、不作为或疏忽导致您无法使用服务。</strong></p>
            <p class="desc"><strong>（5）在适用法律所允许的最大范围内，上海科橘信息科技有限公司或其供应商绝不就因使用或不能使用本软件所引起的或有关的任何间接的、意外的、直接的、特殊的、惩罚性的或其它任何损害承担赔偿责任，即使上海科橘信息科技有限公司或其任何供应商事先被告知该损害发生的可能性。即使补救措施未能达到预定目的，本损害赔偿排除条款将仍然有效。在适用法律所允许的最大范围内，不论何种情况，上海科橘信息科技有限公司及其供应商在本协议任何条款下所承担的全部责任，以您获得本协议约定之本软件授权而支付的合理款项（如有）为限，如您系免费获得本软件，则上海科橘信息科技有限公司及其供应商无义务承担任何责任或向您支付任何赔偿。同时，上海科橘信息科技有限公司对您或第三方使用本软件的服务引起的任何索赔或损害不承担任何责任。</strong></p>
            <p class="desc"><strong>（6）由于关税政策及政府公共政策的多变性及时效性，上海科橘信息科技有限公司不保证其服务一定能够满足您的要求。您因使用本软件或本服务获得的咨询结论仅作为您决策的参考依据，上海科橘信息科技有限公司不就此结论做任何法律上的担保或者保证。上海科橘信息科技有限公司不保证您一定能够享受查询结果或咨询结论所显示的政策优惠，亦不保证满足查询结果或咨询结论显示的条件必然享受相应的政策优惠。</strong></p>
          </section>
          <section>
            <h1>十三、【其他】</h1>
            <p><strong>13.1 您使用本软件或本服务即视为您已阅读并同意受本协议的约束。上海科橘信息科技有限公司有权在必要时修改本协议条款。您可以在本软件、本服务的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件、本服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。</strong></p>
            <p>13.2 本协议签订地为中华人民共和国上海市。</p>
            <p>13.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
            <p>13.4 <strong>若您和上海科橘信息科技有限公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交</strong>上海科橘信息科技有限公司所在地<strong>的人民法院管辖。</strong>。</p>
            <p>13.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
            <p>13.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
          </section>
          <div class="comname">上海科橘信息科技有限公司</div>
        </div>
      </iscroll-view>
    </div>
    <div class="footer">
      <Button type="primary" @click="close">
        <span>{{$t('btn.close')}}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PrivacyContentZH',
  data () {
    return {
      rightNum: 16,
      maxHeight: 0,
      height: 0
    }
  },
  computed: {
    ...mapState('account', {
      isShowModal: state => state.isShowPrivacy
    })
  },
  watch: {
    isShowModal (newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.refresh()
        }, 100)
      }
    }
  },
  mounted () {
    this.refresh()
    this.$nextTick(() => {
      let modalStyle = this._h.getOuterElSize(document.querySelector('.ivu-modal-body'))
      if (modalStyle && modalStyle['paddingWidth'] > 0) {
        this.rightNum = modalStyle['paddingWidth'] / 2
      }
      this.maxHeight = this._h.getWinHeight() - 190
      this.height = this.maxHeight
      this.refresh()
    })
  },
  methods: {
    refresh () {
      this.$refs.iscroll && this.$refs.iscroll.refresh()
    },
    close () {
      this.setModalState(false)
    },
    ...mapMutations({
      setModalState: 'account/setPrivacyModalState'
    })
  }
}
</script>
<style scoped>
  .scroll-view{
    /* -- Attention: This line is extremely important in chrome 55+! -- */
    touch-action: none;
    /* -- Attention-- */
    /*position: fixed;*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
  .content{
    position:relative;
  }
  .footer{
    margin-top: 20px;
  }
  section{
    color: #333;
  }
  section h1{
    font-size: 15px;
    /*font-weight: normal;*/
    margin-bottom: 5px;
    margin-top: 15px;
  }
  section:first-child h1{
    margin-top: 0;
  }
  section p{
    text-indent: 18px;
    margin-bottom: 5px;
    line-height: 26px;
    font-size: 14px;
  }
  section p.desc{
    text-indent: 36px;
  }
  section p.desc2{
    text-indent: 54px;
  }
  section strong{
    font-size: 13px;
  }
  .comname{
    padding: 20px 10px 30px 0;
    text-align: right;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/zh-CN/PrivacyContent.vue